export default __webpack_public_path__ + "static/beats-a4612093443227a9f5cad1dd8ae8a640.png";